var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAmenityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3333 16.5C32.3333 25.2445 25.2445 32.3333 16.5 32.3333C7.75549 32.3333 0.666667 25.2445 0.666667 16.5C0.666667 7.75549 7.75549 0.666667 16.5 0.666667C25.2445 0.666667 32.3333 7.75549 32.3333 16.5Z",
    fill: "#230CC2",
    stroke: "#1822B3",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4868 11.9493V9.89288C24.3175 9.91736 25 10.5895 25 11.4155V23.4672C25 24.3074 24.3011 25 23.4417 25H9.55832C8.69762 25 8 24.3088 8 23.4672V11.4155C8 10.5895 8.68256 9.91736 9.5132 9.89288V11.9493C9.5132 12.8788 10.2843 13.6278 11.2347 13.6278H12.3209C13.2712 13.6278 14.0526 12.8788 14.0526 11.9493V9.8855H18.9474V11.9493C18.9474 12.8788 19.7288 13.6278 20.6793 13.6278H21.7653C22.7157 13.6278 23.4868 12.8788 23.4868 11.9493ZM20.7531 18.6434C20.7531 20.9947 18.8477 22.9008 16.4971 22.9008C14.1466 22.9008 12.2412 20.9947 12.2412 18.6434C12.2412 16.2922 14.1466 14.3861 16.4971 14.3861C18.8477 14.3861 20.7531 16.2922 20.7531 18.6434Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2306 12.5254H12.3048C12.6308 12.5254 12.8952 12.2672 12.8952 11.9484V8.57716C12.8952 8.2583 12.6308 8 12.3048 8H11.2306C10.9045 8 10.6401 8.2583 10.6401 8.57716V11.9484C10.6401 12.2672 10.9045 12.5254 11.2306 12.5254Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6656 12.5254H21.7398C22.0656 12.5254 22.33 12.2672 22.33 11.9484V8.57716C22.33 8.2583 22.0657 8 21.7398 8H20.6656C20.3396 8 20.0752 8.2583 20.0752 8.57716V11.9484C20.0752 12.2672 20.3396 12.5254 20.6656 12.5254Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9946 17.4508C18.1394 17.2997 18.3741 17.2997 18.5189 17.4508C18.6637 17.602 18.6637 17.847 18.5189 17.9981L16.2944 20.3201C16.1489 20.4719 15.9128 20.4711 15.7683 20.3182L14.4774 18.9523C14.3336 18.8001 14.3352 18.5551 14.481 18.405C14.6268 18.2549 14.8615 18.2566 15.0053 18.4088L16.034 19.4973L17.9946 17.4508Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenityIcon);
export default __webpack_public_path__ + "static/media/AmenityIcon.9ae01f8e30b6a716a76db3ab8f9b2242.svg";
export { ForwardRef as ReactComponent };